import React, { useState } from 'react';
import { LogIn, AlertCircle, Bug } from '../theme/icons.js';
import { ThemeToggle } from '../components/ui/ThemeToggle.js';
import { DvLogo } from '../components/ui/DvLogo.js';
import { DoodleLayer } from '../theme/Wegzeichen.js';
import { useFeedback } from '../hooks/useFeedback.js';
import './LoginPage.css';

export default function LoginPage({ message, onLogin }) {
  const feedbackMelden = useFeedback();
  /* Vorbelegung nur außerhalb von Produktions-Builds: CRA schreibt jede
     REACT_APP_*-Variable beim Build als Literal ins öffentliche Bundle. Mit
     einem echten NAMI-Login in der .env hätte jede Besucherin der Anmeldeseite
     die Zugangsdaten im JavaScript gehabt (Security-Audit 09.09.2026, #113).
     Gleicher Schalter wie IS_MOCK in App.js. */
  const prefill = process.env.NODE_ENV !== 'production';
  const [username, setUsername] = useState(prefill ? process.env.REACT_APP_DEFAULT_USER || '' : '');
  const [password, setPassword] = useState(prefill ? process.env.REACT_APP_DEFAULT_PASSWORD || '' : '');
  const [loading, setLoading] = useState(false);
  const [logoError, setLogoError] = useState(false);

  const hasError = message && message !== 'hide';

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    await onLogin({ username, password });
    setLoading(false);
  }

  return (
    <div className="login-bg">
      <DoodleLayer />
      <div className="login-corner">
        <ThemeToggle className="login-corner-btn" />
        <button
          type="button"
          className="login-corner-btn"
          onClick={feedbackMelden}
          aria-label="Feedback / Problem"
          title="Feedback / Problem"
        >
          <Bug size={20} />
        </button>
      </div>
      <div className="login-card">
        {/* Brand */}
        <div className="login-brand">
          {!logoError ? (
            <DvLogo
              groesse="gross"
              alt="DPSG DV Limburg"
              hellKlasse="login-logo login-logo--light"
              dunkelKlasse="login-logo login-logo--dark"
              onError={() => setLogoError(true)}
            />
          ) : (
            <div className="login-logo-fallback">DV</div>
          )}
        </div>

        <h1 className="login-title">DV Limburg Dashboard</h1>
        <p className="login-subtitle">Bitte mit NAMI-Zugangsdaten anmelden</p>

        {hasError && (
          <div className="login-error">
            <AlertCircle size={16} />
            {message}
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          <div className="login-field">
            <label className="login-label" htmlFor="login-user">
              Benutzername
            </label>
            <span className="ff-box">
              <input
                id="login-user"
                className={`login-input ${hasError ? 'login-input-error' : ''}`}
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </span>
          </div>

          <div className="login-field">
            <label className="login-label" htmlFor="login-pass">
              Passwort
            </label>
            <span className="ff-box">
              <input
                id="login-pass"
                className={`login-input ${hasError ? 'login-input-error' : ''}`}
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </span>
          </div>

          <button className="login-btn" type="submit" disabled={loading || message === 'hide'}>
            {loading ? (
              <span className="login-spinner" />
            ) : (
              <>
                <LogIn size={18} /> Anmelden
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
